import React from 'react';

import { frontendUrl } from '../../config/urls';

const TermsOfUse = () => {
  return (
    <div className="legal terms-of-use">
      <h1>Terms Of Use</h1>
      <p>Updated: May 2019</p>
      <p>
        Please read these Terms of Use ("Terms", "Terms of Use") carefully
        before using the <a href={frontendUrl}>{frontendUrl}</a> website (the
        "Service") operated by Hire Lambda ("us", "we", or "our"). Your access
        to and use of the Service is conditioned on your acceptance of and
        compliance with these Terms. These Terms apply to all visitors, users
        and others who access or use the Service.
      </p>

      <p>
        <strong>
          By accessing or using the Service, you agree to be bound by these
          Terms. If you disagree with any part of the terms, you may not access
          the Service.
        </strong>
      </p>

      <h2>General Rules</h2>
      <p>
        To use the Service, you must (a) provide current and accurate
        information; (b) agree to these Terms; and (c) promise to follow these
        rules: (1) You are responsible for all content you provide and your
        activities on the Service; (2) You will use the Service in compliance
        with all applicable laws, rules, and regulations; (3) You will not use
        the Service to solicit the performance of any activity which infringes
        our rights or the rights of others; and (4) You will not use the Service
        to upload, transmit, or otherwise distribute any objectionable content,
        as solely determined by us.
      </p>

      <h2>Termination</h2>
      <p>
        We may terminate or suspend access to our Service immediately, without
        prior notice or liability, for any reason whatsoever, including without
        limitation if you breach the Terms. All provisions of the Terms which by
        their nature should survive termination shall survive termination,
        including, without limitation, ownership provisions, warranty
        disclaimers, indemnity and limitations of liability.
      </p>

      <p>
        As long as you comply with our Terms of Service, we grant you a
        non-exclusive, non-transferable, limited privilege to use the Service.
        Your use of the Service is at your own risk.
      </p>

      <h2>Content</h2>
      <p>
        By creating an account to the Service and providing information or
        content through the Service, you agree the information is yours to share
        and to allow the Service to use and publish that information or content.
      </p>

      <p>
        Some of the Service's features allow you to upload, submit, store, send
        or receive content. You retain ownership of any intellectual property
        rights that you hold in that content. In short, what belongs to you
        stays yours.
      </p>

      <p>
        When you upload, submit, store, send or receive content to or through
        our Services, you give Hire Lambda (and those we work with) a worldwide
        license to use, host, store, reproduce, modify, create derivative works,
        communicate, publish, publicly perform, publicly display and distribute
        such content. The rights you grant in this license are for the limited
        purpose of operating, promoting, and improving the Service, and to
        develop new ones. This license continues even if you stop using our
        Service. The Service may offer you ways to access and remove content.
        Make sure you have the necessary rights to grant us this license for any
        content that you submit to our Services.
      </p>

      <h2>Privacy</h2>
      <p>
        Our Privacy Policy explains how we treat your personal data and protect
        your privacy when you use our Service. By using the Service, you agree
        that Hire Lambda can use your data in accordance with the Privacy
        Policy.
      </p>

      <h2>Your Account</h2>
      <p>
        You may need an account to access some of the features of the Service.
        You are responsible for the activity that happens on or through your
        account. Keep your password or third-party authentication credentials
        confidential.
      </p>

      <p>
        You agree to notify us immediately of any unauthorized use of your
        account(s). We’re not responsible for any losses due to stolen or hacked
        passwords.
      </p>

      <p>
        You will not represent that you are any other individual or entity
        unless such individual or entity has given you written permission to act
        on their behalf.
      </p>

      <h2>Acceptable Use</h2>
      <p>
        Don’t misuse our Service. For example, don’t interfere with our Service
        or try to access the Service using a method other than the interface and
        the instructions that we provide. You may use our Service only as
        permitted by law. We may suspend or stop providing our Service to you if
        you do not comply with our terms or policies or if we are investigating
        suspected misconduct.
      </p>

      <p>
        Using the Service does not give you ownership of any intellectual
        property rights in our Service or the content you access. You may not
        use content from our Services unless you obtain permission from its
        owner or are otherwise permitted by law. Don’t remove, obscure, or alter
        any legal notices displayed in or along with our Services.
      </p>

      <h2>Third-Party Links and Content</h2>
      <p>
        Our Service may contain links to third-party web sites or services that
        are not owned or controlledby ​Hire Lambda. Hire Lambda has no control
        over, and assumes no responsibility for, the content, privacy policies,
        or practices of any third-party web sites or services. You further
        acknowledge andagree that ​Hire Lambda shall not be responsible or
        liable, directly or indirectly, for any damage or loss caused or alleged
        to be caused by or in connection with use of or reliance on any such
        content, goods or services available on or through any such web sites or
        services.
      </p>

      <h2>Changes</h2>
      <p>
        We reserve the right, at our sole discretion, to modify or replace these
        Terms at any time. If a revision is material, we will try to provide at
        least ​30 days' notice prior to any new terms taking effect. What
        constitutes a material change will be determined at our sole discretion.
      </p>

      <h2>Communication</h2>
      <p>
        In connection with your use of the Service, we may send you service
        announcements, administrative messages, and other information. You may
        opt out of some of those communications.
      </p>

      <h2>Indemnification</h2>
      <p>
        You agree to indemnify and hold us harmless from any and all demands,
        loss, liability, claims or expenses (including attorneys’ fees) made
        against us by any third party due to or arising out of or in connection
        with your use of the Service.
      </p>

      <h2>Warranties and Disclaimers</h2>
      <p>
        We provide our Services using a commercially reasonable level of skill
        and care and we hope that you will enjoy using them. But there are
        certain things that we don’t promise about our Services.
      </p>
      <p>
        OTHER THAN AS EXPRESSLY SET OUT IN THESE TERMS OR ADDITIONAL TERMS,
        NEITHER GOOGLE NOR ITS SUPPLIERS OR DISTRIBUTORS MAKE ANY SPECIFIC
        PROMISES ABOUT THE SERVICES. FOR EXAMPLE, WE DON’T MAKE ANY COMMITMENTS
        ABOUT THE CONTENT WITHIN THE SERVICES, THE SPECIFIC FUNCTIONS OF THE
        SERVICES, OR THEIR RELIABILITY, AVAILABILITY, OR ABILITY TO MEET YOUR
        NEEDS. WE PROVIDE THE SERVICES “AS IS”.
      </p>
      <p>
        SOME JURISDICTIONS PROVIDE FOR CERTAIN WARRANTIES, LIKE THE IMPLIED
        WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
        NON-INFRINGEMENT. TO THE EXTENT PERMITTED BY LAW, WE EXCLUDE ALL
        WARRANTIES.
      </p>

      <h2>Liability for our Services</h2>
      <p>
        WHEN PERMITTED BY LAW, THE SERVICE, AND THE SERVICE’S SUPPLIERS AND
        DISTRIBUTORS, WILL NOT BE RESPONSIBLE FOR LOST PROFITS, REVENUES, OR
        DATA, FINANCIAL LOSSES OR INDIRECT, SPECIAL, CONSEQUENTIAL, EXEMPLARY,
        OR PUNITIVE DAMAGES.
      </p>
      <p>
        TO THE EXTENT PERMITTED BY LAW, THE TOTAL LIABILITY OF THE SERVICE, AND
        ITS SUPPLIERS AND DISTRIBUTORS, FOR ANY CLAIMS UNDER THESE TERMS,
        INCLUDING FOR ANY IMPLIED WARRANTIES, IS LIMITED TO THE AMOUNT YOU PAID
        US TO USE THE SERVICES (OR, IF WE CHOOSE, TO SUPPLYING YOU THE SERVICES
        AGAIN).
      </p>
      <p>
        IN ALL CASES, THE SERVICE, AND ITS SUPPLIERS AND DISTRIBUTORS, WILL NOT
        BE LIABLE FOR ANY LOSS OR DAMAGE THAT IS NOT REASONABLY FORESEEABLE.
      </p>

      <h2>Contact Us</h2>
      <p>
        Please contact us if you have any questions about these Terms at{' '}
        <a href="mailto:hirelambda@gmail.com">hirelambda@gmail.com</a>.
      </p>
    </div>
  );
};

export default TermsOfUse;
